import React from 'react';
import { snookerFrameStats } from '../utils/streamingStats';
import './StreamingFrameStats.css';

export default function StreamingFrameStats({ gameState }) {
    const stats = snookerFrameStats(gameState);
    return (
        <div className={`streaming-stats-row-st ${Number(gameState.currentPlayer) === 2 ? 'is-right-st' : 'is-left-st'}`}>
            <section className="streaming-frame-stats-st" aria-label={`Frame statistics for ${stats.player}`}>
                <span className="streaming-stat-st"><span>{stats.label}</span><b>{stats.difference}</b></span>
                <span className="streaming-stat-st"><span>Remaining</span><b>{stats.remaining ?? '—'}</b></span>
                <span className="streaming-stat-st"><span>Reds</span><b>{stats.reds ?? '—'}</b></span>
            </section>
        </div>
    );
}
